/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2023
 * @format
 * @flow
 */

import React from 'react';
import { Box } from '@material-ui/core';
import CreateWaitList from '../../CreateWaitList';
import Waitlist from '../../Waitlist';
import ConfirmationPopup from '../../ConfirmationPopup';
import EditWaitList from '../../EditWaitlist';
import Menu from '../../Menu';

const LeftSection = (props) => {
  const {
    popup,
    onCreateBooking,
    goToWaitlistScreen,
    bookingList,
    bookingStatus,
    onChangeBookingStatus,
    bookingCount,
    stationMap,
    onAddGuest,
    createWaitlistMode,
    onBookingActionClick,
    editWaitlistMode,
    onUpdateBooking,
    selectedBooking,
    onMoveBooking,
    onOpenMenu,
    menuMode,
    onMenuClick,
  } = props;

  const getView = () => {
    if (createWaitlistMode) {
      return (
        <CreateWaitList
          onCreateBooking={onCreateBooking}
          goToWaitlistScreen={goToWaitlistScreen}
        />
      );
    } else if (editWaitlistMode) {
      return (
        <EditWaitList
          booking={selectedBooking}
          goToWaitlistScreen={goToWaitlistScreen}
          onUpdateBooking={onUpdateBooking}
        />
      );
    } else if (menuMode) {
      return (
        <Menu
          goToWaitlistScreen={goToWaitlistScreen}
          onMenuClick={onMenuClick}
        />
      );
    } else {
      return (
        <Waitlist
          bookingList={bookingList}
          bookingStatus={bookingStatus}
          onChangeBookingStatus={onChangeBookingStatus}
          bookingCount={bookingCount}
          stationMap={stationMap}
          onAddGuest={onAddGuest}
          onBookingActionClick={onBookingActionClick}
          onMoveBooking={onMoveBooking}
          onOpenMenu={onOpenMenu}
        />
      );
    }
  };

  return (
    <Box position={'relative'}>
      {getView()}
      {(!!popup && popup?.type === 'confirmation') && (
        <ConfirmationPopup {...popup} />
      )}
    </Box>
  );
};

export default LeftSection;
